import Vue from 'vue'
import store from './../../store'

const returnToIndex = () => {
  store.dispatch('auth/logout')
  Vue.router.push({
    name: 'login.index',
  })
}

export default () => {
  const token = store.state.auth.accessToken
  const request = Vue.$http.post('auth/token-verify/', {token})
  return request
}


// WEBPACK FOOTER //
// ./src/services/auth/verifyToken.js